<template>
  <a
    :href="href"
    :target="target"
    :rel="rel"
    :aria-label="ariaLabel"
    :title="title"
    :aria-describedby="isExternalLink ? 'external-link-sr-only' : undefined"
  >
    <slot></slot>
    <span v-if="!hideIcon && isExternalLink" class="external__link">
      <site-icon icon="external-link" :size="14"></site-icon>
    </span>
  </a>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { isExternalUrl } from '@app/utils/functions/isExternalUrl';

interface IProps {
  href: string | undefined;
  hideIcon?: boolean;
  target?: string;
  ariaLabel?: string;
  title?: string;
}

const props = defineProps<IProps>();

const hideIcon = computed(() => props.hideIcon ?? false);

const fullHref = computed(() => {
  return props.href?.startsWith('/') ? window.location.origin + props.href : props.href;
});

const isExternalLink = computed(() => {
  if (!fullHref.value) return false;
  return isExternalUrl(fullHref.value);
});

const target = computed(() => {
  return isExternalLink.value && !props.target ? '_blank' : props.target;
});

const rel = computed(() => {
  return isExternalLink.value ? 'noopener noreferrer' : undefined;
});
</script>

<style lang="scss" scoped>
@import '@style/_sfc';

a {
  &:hover {
    .external__link svg {
      path {
        fill: $color-primary-theta;
      }
    }
  }

  .external__link span {
    margin-left: rem(5);
    margin-bottom: rem(3);
  }
}
</style>
